import React, { useEffect, useState } from "react";
import { useParams, useNavigate, Link } from "react-router-dom";
import axios from "axios";
import { Form, Row, Col, Button } from "react-bootstrap";
import { useAuth } from "../context/AuthContext";

const API_URL = process.env.REACT_APP_API_URL;

function UserEdit() {
    const { id } = useParams();
    const navigate = useNavigate();
    const { user: loggedUser } = useAuth();


    const [username, setUsername] = useState("");
    const [password, setPassword] = useState("");
    const [email, setEmail] = useState("");
    const [active, setActive] = useState("0");
    const [role, setRole] = useState("0");
    const [center, setCenter] = useState("");

    const [successMsg, setSuccessMsg] = useState("");
    const [errorMsg, setErrorMsg] = useState("");

    const isDisabled = loggedUser?.role === 0 || loggedUser?.role === "0";

    const handleSubmit = async (e) => {
        e.preventDefault();
        const token = localStorage.getItem("token");

        try {
            const res = await axios.put(
                `${API_URL}/user_update/${id}`,
                { username, email, password, active, role, center },
                { headers: { Authorization: `Bearer ${token}` } }
            );

            // alert(res.data.message);
            // navigate("/user_list");

            setSuccessMsg(res.data.message || "Update successfully");
            setErrorMsg("");

            setTimeout(() => {
                navigate("/user_list");
            }, 1000);

        } catch (err) {
            console.error(err);
            // alert("Error updating user!");
            setErrorMsg("Error updating user!");

            setTimeout(() => setErrorMsg(""), 1000);
        }
    };
    const [center_list, setCenter_list] = useState([]);

    useEffect(() => {
        const token = localStorage.getItem("token");
        if (!token) return;
        axios.get(`${API_URL}/get_center_list`, {
            headers: { Authorization: `Bearer ${token}` }
        })
            .then((res) => {
                setCenter_list(res.data.center_list || []);
                console.log("Center List:", res.data.center_list);
            })
            .catch((err) => {
                console.error("Center list error:", err);
            });
    }, []);



    useEffect(() => {
        const token = localStorage.getItem("token");
        if (!token) return;

        axios
            .get(`${API_URL}/user_data_id_wise/${id}`, {
                headers: { Authorization: `Bearer ${token}` },
            })
            .then((res) => {
                const user = res.data.user;
                setUsername(user.username);
                setEmail(user.email);
                setActive(user.active.toString());
                setRole(user.role.toString());
                setCenter(user.center ? user.center : "");
            })
            .catch((err) => console.error(err));
    }, [id]);





    return (
        <div
            className="container mt-4"
            style={{ backgroundColor: "#f0f8ff", minHeight: "70vh", padding: "20px" }}
        >
            {successMsg && (
                <div className="alert alert-success mt-2">
                    {successMsg}
                </div>
            )}

            {errorMsg && (
                <div className="alert alert-danger mt-2">
                    {errorMsg}
                </div>
            )}
            <h3 className="d-flex justify-content-between align-items-center">
                User Update

                <div>
                    <Link
                        className="btn btn-sm btn-primary me-2"
                        to="/register"
                        disabled={isDisabled}
                        style={{ pointerEvents: isDisabled ? "none" : "auto", opacity: isDisabled ? 0.5 : 1 }}
                    >
                        Add User
                    </Link>

                    <Link
                        className="btn btn-sm btn-primary"
                        to="/UserList"
                        disabled={isDisabled}
                        style={{ pointerEvents: isDisabled ? "none" : "auto", opacity: isDisabled ? 0.5 : 1 }}
                    >
                        User List
                    </Link>
                </div>
            </h3>

            <Form onSubmit={handleSubmit}>
                <Row>
                    <Col xs={12} md={6} className="mb-3">
                        <Form.Label>Username</Form.Label>
                        <Form.Control
                            type="text"
                            value={username}
                            onChange={(e) => setUsername(e.target.value)}
                            required
                            disabled={isDisabled}
                        />
                    </Col>

                    <Col xs={12} md={6} className="mb-3">
                        <Form.Label>Password</Form.Label>
                        <Form.Control
                            type="password"
                            value={password}
                            onChange={(e) => setPassword(e.target.value)}
                            required
                            disabled={isDisabled}
                        />
                    </Col>

                    <Col xs={12} md={6} className="mb-3">
                        <Form.Label>Email</Form.Label>
                        <Form.Control
                            type="email"
                            value={email}
                            onChange={(e) => setEmail(e.target.value)}
                            required
                            disabled={isDisabled}
                        />
                    </Col>

                    <Col xs={12} md={6} className="mb-3">
                        <Form.Label className="d-block">Active</Form.Label>

                        <Form.Check
                            inline
                            label="Yes"
                            type="radio"
                            name="active"
                            value="0"
                            checked={active === "0"}
                            onChange={(e) => setActive(e.target.value)}
                            disabled={isDisabled}
                        />

                        <Form.Check
                            inline
                            label="No"
                            type="radio"
                            name="active"
                            value="1"
                            checked={active === "1"}
                            onChange={(e) => setActive(e.target.value)}
                            disabled={isDisabled}
                        />
                    </Col>

                    <Col xs={12} md={6} className="mb-3">
                        <Form.Label className="d-block">Role</Form.Label>

                        <Form.Check
                            inline
                            label="Principal Investigator"
                            type="radio"
                            name="role"
                            value="1"
                            checked={role === "1"}
                            onChange={(e) => setRole(e.target.value)}
                            disabled={isDisabled}
                        />

                        <Form.Check
                            inline
                            label="User Login"
                            type="radio"
                            name="role"
                            value="0"
                            checked={role === "0"}
                            onChange={(e) => setRole(e.target.value)}
                            disabled={isDisabled}
                        />
                    </Col>

                    <Col xs={12} md={6} className="mb-3">
                        <label className="form-label">
                            <b>Select Center</b>
                        </label>


                        <select
                            className="form-select"
                            value={center}
                            onChange={(e) => setCenter(e.target.value)}
                            disabled={isDisabled} required
                        >
                            <option value="">-- Select Center --</option>
                            {center_list.map((c) => (
                                <option key={c.centres_id} value={c.centres_id}>
                                    {c.center_name}
                                </option>
                            ))}
                        </select>
                    </Col>

                    <Col xs={12} className="d-flex justify-content-center mt-3">
                        <Button
                            type="submit"
                            className="px-4"
                            disabled={isDisabled}
                        >
                            Update User
                        </Button>
                    </Col>
                </Row>
            </Form>
        </div>
    );
}

export default UserEdit;
